import React from 'react';
import PropTypes from 'prop-types';
import Badge from '../Badge/Badge';
import Switch from '../Switch/Switch';
import Text from '../Text/Text';
import { elo as theme } from '../../themes';
import { jsx as ___EmotionJSX } from "@emotion/core";
var preventPropagation = function preventPropagation(e) {
  return e.stopPropagation();
};
var AccordionTitle = function AccordionTitle(_ref) {
  var badge = _ref.badge,
    customTitle = _ref.customTitle,
    small = _ref.small,
    switchParams = _ref.switchParams,
    title = _ref.title;
  var renderTitle = function renderTitle() {
    return ___EmotionJSX(React.Fragment, null, title && ___EmotionJSX(Text, {
      semibold: true,
      size: small ? 't3' : 't2'
    }, title), customTitle && ___EmotionJSX("div", {
      onClick: preventPropagation,
      onKeyDown: function onKeyDown() {},
      role: "button",
      style: {
        outline: 'none'
      },
      tabIndex: "0"
    }, customTitle));
  };
  var renderRightSection = function renderRightSection() {
    return ___EmotionJSX("section", null, badge && renderBadge(), (switchParams == null ? void 0 : switchParams.onChange) && renderSwitch());
  };
  var renderBadge = function renderBadge() {
    return ___EmotionJSX(Badge, {
      active: badge.status === 'active',
      notification: badge.status === 'notification',
      minimal: badge.minimal === true,
      variant: badge.variant
    }, badge.text);
  };
  var renderSwitch = function renderSwitch() {
    return ___EmotionJSX("div", {
      onClick: preventPropagation,
      onKeyDown: function onKeyDown() {},
      role: "button",
      style: {
        display: 'flex',
        outline: 'none'
      },
      tabIndex: "0"
    }, switchParams.label && ___EmotionJSX(Text, {
      size: "t4",
      style: {
        marginRight: theme.spacings.xxxSmall
      }
    }, switchParams.label), ___EmotionJSX(Switch, {
      checked: switchParams.checked,
      onChange: switchParams.onChange
    }));
  };
  return ___EmotionJSX(React.Fragment, null, renderTitle(), renderRightSection());
};
AccordionTitle.propTypes = {
  badge: PropTypes.shape({
    text: PropTypes.string.isRequired,
    status: PropTypes.oneOf(['active', 'notification']),
    minimal: PropTypes.bool,
    variant: PropTypes.oneOf(['positive', 'informative', 'negative', null])
  }),
  customTitle: PropTypes.node,
  small: PropTypes.bool,
  switchParams: PropTypes.object,
  title: PropTypes.string
};
export default AccordionTitle;